import { defineComponent, ref, watch } from "vue";
import SvgIcon from "./SvgIcon.vue.mjs";
import ArrowDown from "../icons/ArrowDown.vue.mjs";
import "../../../directives/vTap.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ActionSheep",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    showClose: {
      type: Boolean,
      default: true
    },
    showMask: {
      type: Boolean,
      default: true
    },
    height: {
      type: String,
      default: ""
    }
  },
  emits: ["input", "close"],
  setup(__props, { emit }) {
    const props = __props;
    const show = ref(false);
    watch(
      () => props.visible,
      (val) => show.value = val,
      { immediate: true }
    );
    watch(
      show,
      (val) => {
        emit("input", val);
      },
      { immediate: true }
    );
    const toggleShow = () => {
      show.value = !show.value;
      if (!show.value) {
        emit("close");
      }
    };
    return { __sfc: true, props, emit, show, toggleShow, SvgIcon, ArrowDown };
  }
});
export {
  _sfc_main as default
};
